<template>
  <div>
    <BreadCrumb v-if="this.mode !== 'comp'" :data="breadCrumb" />
    
    <b-card class="formGroup">
      <b-spinner v-if="isLoading" variant="primary" label="Spinning"></b-spinner>
      <Form v-else ref="StockForm" :loading="isLoading" :data="stock" :forms="StockForm" />
      <template v-slot:footer class="footer">
        <b-button :disabled='isLoading' variant="primary" @click="saveForm">Kaydet</b-button>
      </template>
    </b-card>
  </div>
</template>

<script>
let breadCrumb = [
  { label: 'Stoklar', url: "/Stock/List" },
  { label: 'Düzenle', url: "#" },
];

import BreadCrumb from "@/components/BreadCrumb";
import Form from '@/components/Form'
import {prepareRequestData} from '@/assets/js/custom.js'
import Forms from './forms'
export default {
  data() {
    return {
      breadCrumb,
      StockForm: Forms.Stock
    }
  },
  components: {
    BreadCrumb, Form
  },
  created: async function(){
    await this.$store.dispatch('stock_detail', {id:this.$route.params.id })

  },
  computed: {
    stock() {
      return this.$store.getters.stock
    },
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    stockStatus() {
      return this.$store.getters.getStockStatus
    }
  },
  methods: {
    saveForm() {
      this.$refs.StockForm.$refs.Form.validate()
      .then(async success => {
        if (success) {
          let data = prepareRequestData(this.StockForm,  this.$refs.StockForm.formData)
          data.id = this.$route.params.id
          await this.$store.dispatch('editStock', data)
          
          if(this.stockStatus.status == 'Success') {
            return this.$router.push('/Stock/List')
          }
        }
      })
    }
  },
}
</script>

<style>
    @import "./styles/add.min.css"; 

</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/Edit.vue